import Vue from 'vue';
import VueRouter from 'vue-router';

// import store from '../store';
import Lesson from '../views/pages/lesson/edit.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/termos',
    name: 'Termos e Serviços',
    component: () => import('../views/pages/termos'),
  },
  {
    path: '/Recursos',
    name: 'Drag and Drop',
    component: () => import('../views/pages/teste'),
  },
  {
    path: '/entrar',
    name: 'Auth',
    component: () => import('../views/pages/auth'),
  },
  {
    path: '/plano/:name_plan',
    name: 'Buy Page',
    component: () => import('../views/pages/home/buy_plan'),
  },
  {
    path: '/entrar/status',
    name: 'Status',
    component: () => import('../views/pages/auth/status'),
  },
  // {
  //   path: '/admin/login',
  //   name: 'Login',
  //   component: () => import('../views/pages/admin/login')
  // },
  {
    path: '/admin/',
    name: 'Admin',
    component: () => import('../views/pages/admin/home'),
    meta: {
      requiresAuth: true,
      isAdmin: true,
    },
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/pages/home'),
  },
  {
    path: '/teacher',
    component: () => import('../views/layout'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'Teacher',
        component: () => import('../views/pages/teacher'),
      },
      {
        path: 'courses',
        component: () => import('../views/pages/teacher/courses'),
        children: [
          {
            path: '',
            component: () => import('../views/pages/teacher/courses/list'),
          },
          {
            path: 'new',
            component: () => import('../views/pages/teacher/courses/new'),
          },
          {
            path: ':id',
            component: () => import('../views/pages/teacher/courses/edit'),
          },
          {
            path: ':courseId/:moduleId/lesson/:id',
            name: 'lesson',
            // component: Lesson,
            component: () => import('../views/pages/lesson/edit2.vue'),
          },
        ],
      },
      {
        path: 'financial',
        component: () => import('../views/pages/teacher/financial'),
      },
      {
        path: 'metrics',
        component: () => import('../views/pages/teacher/metrics'),
      },
      {
        path: 'notifications',
        component: () => import('../views/pages/teacher/notifications'),
      },
      {
        path: 'settings',
        component: () => import('../views/pages/teacher/settings'),
      },
      {
        path: 'support',
        component: () => import('../views/pages/teacher/suport'),
      },
      {
        path: '/teste',
        name: 'Drag and Drop',
        component: () => import('../views/pages/teste'),
      },
      // {
      //   path: 'admin',
      //   component: () => import('../views/pages/admin/home'),
      //   meta: {
      //     requiresAuth: true,
      //     isAdmin: true
      //   }
      // }
    ],
  },
  {
    path: '/teacher/:samuel',
    component: () => import('../views/layout/index_public'),
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: '',
        name: 'Teacher',
        component: () => import('../views/pages/teacher'),
      },
      {
        path: 'courses',
        component: () => import('../views/pages/teacher/courses'),
        children: [
          {
            path: '',
            component: () => import('../views/pages/teacher/courses/list'),
          },
          {
            path: 'new',
            component: () => import('../views/pages/teacher/courses/new'),
          },
          {
            path: ':id',
            component: () => import('../views/pages/teacher/courses/edit'),
          },
          {
            path: 'lesson/:id',
            name: 'lesson',
            component: Lesson,
          },
        ],
      },
      {
        path: 'financial',
        component: () => import('../views/pages/teacher/financial'),
      },
      {
        path: 'metrics',
        component: () => import('../views/pages/teacher/metrics'),
      },
      {
        path: 'notifications',
        component: () => import('../views/pages/teacher/notifications'),
      },
      {
        path: 'settings',
        component: () => import('../views/pages/teacher/settings'),
      },
      {
        path: 'support',
        component: () => import('../views/pages/teacher/suport'),
      },
      {
        path: 'admin',
        component: () => import('../views/pages/admin/home'),
        meta: {
          requiresAuth: true,
          isAdmin: true,
        },
      },
    ],
  },
  {
    path: '/course/:id/:courseId/:courseName',
    name: 'Course',
    component: () => import('../views/pages/course/view'),
  },
  {
    path: '/:slug',
    name: 'Pagina Publica',
    component: () => import('../views/pages/teacher/pagePublic'),
    children: [
      {
        path: '/:slug/curso/:courseName',
        name: 'Detalhes do Curso',
        component: () => import('../views/pages/course/courseInfo'),
        // children:[
        //   {
        //     path: '/:slug/curso/:courseName/buyCourse',
        //     name: 'Comprar Curso',
        //     component: () => import('../views/pages/aluno'),
        //   },
        // ]
      },
    ],
  },
  // {
  //   path: '/:slug/curso/Estrutura-de-Dados-em-C',
  //   name: 'Detalhes',
  //   component: () => import('../views/pages/course/courseInfo'),
  // },
  {
    path: '/teste/buyCourse',
    name: 'Comprar Curso',
    component: () => import('../views/pages/aluno'),
  },
  {
    path: '/overview/learning',
    name: 'Overview Curso',
    component: () => import('../views/pages/course/overview'),
  },
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/404',
    component: () => import('../views/pages/erro'),
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(_, _2, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Adapt-e';

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const loggedIn = localStorage.getItem('token');

    if (loggedIn) {
      next();
      return;
    }

    next('/');
  } else {
    next();
  }
});

export default router;
